import { FormControlLabel, Checkbox, FormHelperText, FormControl } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";

const CheckboxField = ({ name, label, disabled, ...rest }) => {
  const { control } = useFormContext();

  return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value, ref }, fieldState }) => (
          <>
            <FormControl error={!!fieldState.error} fullWidth>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!value}
                    onChange={onChange}
                    inputRef={ref}
                    disabled={disabled}
                    {...rest}
                  />
                }
                label={label}
              />
              {fieldState.error && <FormHelperText>{fieldState.error?.message}</FormHelperText>}
            </FormControl>
          </>
        )}
      />
  );
};

CheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default CheckboxField;
